var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.38.276H8.828A8.828 8.828 0 0 0 0 9.103v317.793a8.829 8.829 0 0 0 8.828 8.828H185.38V.276z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE15A",
    cx: 185.446,
    cy: 168,
    r: 79.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.932 141.517v35.31c0 14.603-11.88 26.483-26.483 26.483s-26.483-11.88-26.483-26.483v-35.31h52.966zm8.827-17.655h-70.621a8.829 8.829 0 0 0-8.828 8.828v44.138c0 24.376 19.762 44.138 44.138 44.138 24.376 0 44.138-19.762 44.138-44.138V132.69a8.827 8.827 0 0 0-8.827-8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.932 141.517v35.31c0 14.603-11.88 26.483-26.483 26.483s-26.483-11.88-26.483-26.483v-35.31h52.966",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145 128)",
    fill: "#FFE15A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.069,
    cy: 4.69,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.69,
    cy: 4.69,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.069,
    cy: 40,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.69,
    cy: 40,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.379,
    cy: 4.69,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.884,
    cy: 72.552,
    r: 4.414
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.404,
    cy: 72.552,
    r: 4.414
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.149 165.762v7.602a5.709 5.709 0 0 1-5.702 5.702 5.709 5.709 0 0 1-5.702-5.702v-7.602h11.404m0-18.022v7.602a5.709 5.709 0 0 1-5.702 5.702 5.709 5.709 0 0 1-5.702-5.702v-7.602h11.404m0 36.229v7.602a5.709 5.709 0 0 1-5.702 5.702 5.709 5.709 0 0 1-5.702-5.702v-7.602h11.404m15.357-18.207v7.602a5.709 5.709 0 0 1-5.702 5.702 5.709 5.709 0 0 1-5.702-5.702v-7.602h11.404m-30.712 0v7.602a5.709 5.709 0 0 1-5.702 5.702 5.709 5.709 0 0 1-5.702-5.702v-7.602h11.404",
    fill: "#41479B"
  }))));
}

export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,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'";
export { SvgPt as ReactComponent };